export default __webpack_public_path__ + "static/media/thumbnail.84d9beb1.png";